import { TablePagination } from "@mui/material";
import MaterialTable from "material-table";
import React, { forwardRef } from "react";
import {
  ContentLoader,
  ContentPagination,
  ContentTableList,
  EmptyState,
  useStyles,
} from "./MyCasesListComponent.styled";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import LogoutIcon from "@mui/icons-material/Logout";
import moment from "moment";
import ErrorIcon from "@mui/icons-material/Error";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import FiltersByCases from "../FiltersByCases/FiltersByCases";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import PropTypes from "prop-types";
import { theme as themeConfig } from "../../themes/themes";
import { ReactComponent as NoFormSelectedIcon } from "../../assets/svg/no-form-selected.svg";

const MyCasesListComponent = forwardRef((props, ref) => {
  const classes = useStyles();

  return (
    <>
      <FiltersByCases
        ref={ref}
        myListStatuses={props.myListStatuses}
        handleChangeStatus={props.handleChangeStatus}
        rDateValue={props.rDateValue}
        handleChangeDate={props.handleChangeDate}
        activeHightPriority={props.activeHightPriority}
        setActiveHightPriority={props.setActiveHightPriority}
        handleSearch={props.handleSearch}
        showCards={props.showCards}
        setShowCards={props.setShowCards}
        resetFilters={props.resetFilters}
      />
      {props.loadingFirstCases ||
      props.loadingAfterCases ||
      props.loadingBeforeCases ? (
        <ContentLoader>
          <PointersLine color={themeConfig.text.primary} />
        </ContentLoader>
      ) : null}

      {!props.loadingFirstCases &&
      !props.loadingAfterCases &&
      !props.loadingBeforeCases ? (
        <ContentTableList>
          {!props.showCards && (
            props.myCasesList.length === 0 ? (
              <EmptyState>
                <NoFormSelectedIcon />
                <p>No records to display</p>
              </EmptyState>
            ) : (
            <MaterialTable
              title=""
              columns={[
                {
                  title: "Case ID",
                  field: "idCase",
                  type: "string",
                },
                {
                  title: "High Priority",
                  field: "highPriority",
                  type: "string",
                  render: (rowData) => (
                    <Tooltip title={"High Priority"} style={{ zIndex: 0 }}>
                      <IconButton>
                        {rowData.highPriority ? (
                          <ErrorIcon
                            style={{ fontSize: "16px", color: themeConfig.status.error }}
                          />
                        ) : (
                          ""
                        )}
                      </IconButton>
                    </Tooltip>
                  ),
                },
                {
                  title: "Form",
                  field: "form",
                  type: "string",
                  render: (rowData) => rowData?.idFormNavigation?.name,
                },
                {
                  title: "Submission Date",
                  field: "submissionDate",
                  type: "string",
                  render: (rowData) =>
                    moment(rowData.createDate).format("YYYY-MM-DD"),
                },
                {
                  title: "Being managed by",
                  field: "beingManageBy",
                  type: "string",
                  render: (rowData) =>
                    rowData?.handlerUserInfo?.ccmsuser
                      ? rowData.handlerUserInfo.ccmsuser
                      : "...",
                },
                {
                  title: "State",
                  field: "status",
                  type: "string",
                },
                {
                  title: "",
                  field: "internal_action",
                  render: (rowData) =>
                    rowData && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          zIndex: 0,
                        }}
                      >
                        {rowData?.hasAttachment && (
                          <Tooltip title={"Attach File"}>
                            <IconButton>
                              <AttachFileIcon style={{ fontSize: "16px" }} />
                            </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip title="Detail">
                          <IconButton
                            className={classes.delete}
                            onClick={() => props.handleSeeDetails(rowData)}
                          >
                            <LogoutIcon
                              style={{ fontSize: "16px", color: themeConfig.text.primary }}
                            />
                          </IconButton>
                        </Tooltip>
                      </div>
                    ),
                },
              ]}
              data={props.myCasesList}
              options={{
                search: false,
                paging: false,
                maxBodyHeight: 450,
                headerStyle: {
                  zIndex: 1,
                  fontWeight: "bold",
                  backgroundColor: themeConfig.neutral.gray[900],
                  padding: "5px 16px",
                  textAlign: "center",
                },
                cellStyle: {
                  padding: "5px 10px",
                  fontSize: "14px",
                  textAlign: "center",
                },
                rowStyle: (rowData) => ({
                  backgroundColor:
                    rowData.tableData.id % 2 === 0 ? "#FFFFFF" : "#F0F0F0",
                }),
              }}
            ></MaterialTable>
            )
          )}
          {props.showCards && (
            <ViewControlMenu
              title={""}
              identity={"my-cases"}
              showCards={props.showCards}
              setShowCards={props.setShowCards}
              list={props.myCasesList}
              isAgent={false}
              handleSeeDetails={props.handleSeeDetails}
            />
          )}
          {props.myCasesList.length > 0 ? (
            <ContentPagination>
              <TablePagination
                component="div"
                style={{ display: "flex", justifyContent: "end" }}
                count={props.allPages}
                page={props.page}
                onPageChange={props.handleChangePage}
                rowsPerPage={props.rowsPerPage}
                rowsPerPageOptions={props.rowsPerPageOptions}
                onRowsPerPageChange={props.handleChangeRowsPerPage}
              />
            </ContentPagination>
          ) : (
            <></>
          )}
        </ContentTableList>
      ) : null}
    </>
  );
});

export default MyCasesListComponent;

MyCasesListComponent.propTypes = {
  props: PropTypes.object.isRequired,
  ref: PropTypes.object.isRequired,
};
